import store from '@/store'
import Cookies from 'js-cookie'
import { AUTH_SWITCH } from '@/config/auth'

const TokenKey = 'Admin-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function hasAuth (resId) {
  return !AUTH_SWITCH ||
         store.getters.currentPageAuth.includes(resId.toString()) ||
         store.getters.specialAuth.includes(resId.toString())
}
